<div class="app-shell">
  <!-- Page Header - Show on all pages except dashboard and landing page -->
  <!-- <app-page-header *ngIf="!isDashboard && !isLandingPage"></app-page-header> -->
  <!-- <main *ngIf="isDashboard || isLandingPage">
    <router-outlet />
  </main>  -->
  <app-page-header *ngIf="!isLandingPage"></app-page-header>
  <main *ngIf="isLandingPage">
    <router-outlet />
  </main>
  <app-user-sync-handler *ngIf="!isDashboard"></app-user-sync-handler>
</div>
